export default __webpack_public_path__ + "static/media/goi.a8ca3f15.svg";